<template>
  <ShareActivity
    :auth="auth"
    @navigate="$emit('navigate', $event)"
  />
</template>

<script>
import ShareActivity from './ShareActivity.vue'

export default {
  name: 'OurShares',
  components: {
    ShareActivity: ShareActivity
  },
  props: {
    auth: {
      type: Object,
      required: true
    }
  }
}
</script>
